export default __webpack_public_path__ + "static/media/logo_mvs-noticias.bbe47114.svg";